module.exports = __webpack_public_path__ + "img/heygov-logo-square.60c85c72.png";